export default "__VITE_ASSET__BCR3b79D__"